import { render, staticRenderFns } from "./Franchises.vue?vue&type=template&id=6ea96438&scoped=true"
import script from "./Franchises.vue?vue&type=script&lang=js"
export * from "./Franchises.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ea96438",
  null
  
)

export default component.exports